import React, { useState, useEffect } from "react";
import axios from "axios";
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { Link } from 'react-router-dom';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import { baseUrl } from '../Univ.js';

function PurchaseGstReport(props) {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [addedby, setAddedby] = useState('');
  const [mode, setMode] = useState('');
  const [rows, setRows] = useState([]);
  const [userData, setUserData] = useState([]);
  const [combinedData, setCombinedData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const handleStartDateChange = (date) => {
  const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  setStartDate(localDate);
};

  const handleEndDateChange = (date) => {
  const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  setEndDate(localDate);
};

  const handleUser = (event) => {
    setAddedby(event.target.value);
  };

  const handleMode = (event) => {
    setMode(event.target.value);
  };

  useEffect(() => {
    axios.get(`${baseUrl}user-search/`)
      .then(response => {
        setUserData(response.data);
      })
      .catch(error => {
        console.error('Error fetching user data:', error);
      });
  }, []);

  useEffect(() => {
    fetchData();
  }, [startDate, endDate, addedby, mode]);

  useEffect(() => {
    if (combinedData.length > 0) {
      setRows(combinedData);
    }
  }, [combinedData]);

  function fetchData() {
    setIsLoading(true);
    const startDateString = startDate ? startDate.toISOString().substring(0, 10) : '';
    const endDateString = endDate ? endDate.toISOString().substring(0, 10) : '';
    const url = `${baseUrl}all-pharm-grn/?start_date=${startDateString}&end_date=${endDateString}&addedby=${addedby}&mode=${mode}&status=1`;

    axios.get(url)
      .then(response => {
        setCombinedData(response.data);
        setIsLoading(false);
      })
      .catch(error => {
        console.error('Error fetching combined data:', error);
        setIsLoading(false);
      });
  }

  const getTotal = (rows, field) => {
    return rows.reduce((total, row) => {
      const values = row[field].split(',').map(value => parseFloat(value.trim()));
      const sum = values.reduce((acc, value) => acc + value, 0);
      return total + sum;
    }, 0);
  };

  const columns = [
    { field: 'grn_date_date', headerName: 'Date', width: 100 },
    { field: 'type', headerName: 'Payment Mode', width: 120 },
    { field: 'dist__name', headerName: 'Distributor', width: 220 },
    { field: 'dist__gst', headerName: 'Dist GST', width: 180 },
    {
      field: 'grn_no',
      headerName: 'GRN No',
      renderCell: (params) => {
        const invoiceLink = `/grn-invoice/${params.row.grn_no}`;
        return (
          <Link to={invoiceLink} target="_blank">
            {params.row.grn_no}
          </Link>
        );
      },
      width: 120
    },
    {
      field: 'grnamount',
      headerName: 'GRN Amount',
      width: 120
    },
    {
      field: 'gstamount',
      headerName: 'CGST',
      renderCell: (params) => {
        const gstAmounts = params.value.split(',').map(amount => parseFloat(amount.trim()));
        const sum = gstAmounts.reduce((total, amount) => total + amount, 0);
        return (sum / 2).toFixed(2);
      },
      width: 120
    },
    {
      field: 'gstamount',
      headerName: 'SGST',
      renderCell: (params) => {
        const gstAmounts = params.value.split(',').map(amount => parseFloat(amount.trim()));
        const sum = gstAmounts.reduce((total, amount) => total + amount, 0);
        return (sum / 2).toFixed(2);
      },
      width: 120
    },
    {
      field: 'invamount',
      headerName: 'Invoice Amount',
      width: 120
    },
    { field: 'invoice', headerName: 'Invoice', width: 100 },
  ];

  const Footer = ({ rows }) => {
    const totalGstAmount = getTotal(rows, 'gstamount');
    const totalInvAmount = getTotal(rows, 'invamount');
    const totalPurAmount = totalInvAmount - totalGstAmount;

    return (
      <div style={{ display: 'flex', justifyContent: 'space-evenly', padding: '8px' }}>
        <div>{'Purchase Amount: ' + totalPurAmount?.toFixed(2)}</div>
        <div>{'CGST Amount: ' + (totalGstAmount / 2)?.toFixed(2)}</div>
        <div>{'SGST Amount: ' + (totalGstAmount / 2)?.toFixed(2)}</div>
        <div>{'Invoice Amount: ' + totalInvAmount?.toFixed(2)}</div>
      </div>
    );
  };

  const today = new Date();

  return (
    <section className="container mt-4">
      <h3 className="text-center" style={{ color: 'black', backgroundColor: '#e5eaef' }}>
        <i className="fa-solid fa-calendar-days" aria-hidden="true" style={{ color: 'red' }}></i> Purchase GST Report
      </h3>
      <div className="row">
        <div className="col-md-4">
          <label className="control-label">Select Date</label>
          <DatePicker
            selected={startDate}
            onChange={handleStartDateChange}
            selectsStart
            startDate={startDate}
            endDate={endDate}
            placeholderText={'Please select From date'}
            dateFormat="dd/MM/yyyy"
            showMonthDropdown
            showYearDropdown
          />
          <DatePicker
            selected={endDate}
            onChange={handleEndDateChange}
            selectsEnd
            startDate={startDate}
            endDate={endDate}
            minDate={startDate}
            maxDate={today}
            placeholderText={'Please select To date'}
            dateFormat="dd/MM/yyyy"
            showMonthDropdown
            showYearDropdown
          />
        </div>

        <div className="col-md-4">
          <div className="mb-4 mt-4 form-control">
            <label htmlFor="user" className="form-label">Search by Cashier</label>
            <select name="user" id="username" value={addedby} className="form-control"
              onChange={handleUser}>
              <option value="">Select Cashier</option>
              {userData.map((user, index) => (
                <option key={index} value={user.username}>{user.username}</option>
              ))}
            </select>
          </div>
        </div>

        <div className="col-md-4">
          <div className="mb-4 mt-4 form-control">
            <label htmlFor="mode" className="form-label">Search by Purchase Mode</label>
            <select name="mode" id="mode" value={mode} className="form-control"
              onChange={handleMode}>
              <option value="">Select Purchase Mode</option>
              <option value="CreditPurchase">Credit Purchase</option>
              <option value="CashPurchase">Cash Purchase</option>
            </select>
          </div>
        </div>
      </div>

      {!isLoading && combinedData.length > 0 ? (
        <div style={{ height: "100%", width: "100%" }}>
          <DataGrid className="mt-4"
            sx={{
              boxShadow: 4,
              border: 4,
              borderColor: 'primary.light',
              '& .MuiDataGrid-cell:hover': {
                color: 'primary.main',
              },
            }}
            rows={rows}
            columns={columns}
            pageSize={10}
            slots={{
              toolbar: GridToolbar,
              footer: () => <Footer rows={rows} />,
            }}
            autoHeight
          />
        </div>
      ) : (
        <>loading pls wait....</>
      )}
    </section>
  );
}

export default PurchaseGstReport;
